<script setup lang="ts">
const { dispatch } = useStore();

onMounted(() => {
   dispatch('language/get');
});
</script>

<template>
   <div class="pool-index">
      <RouterView></RouterView>
   </div>
</template>

<style lang="scss" scoped>
.pool-index {
   width: 100%;
   height: calc(100% - var(--nxt-gutter));
}
</style>
